var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductExplanation',{attrs:{"type":_vm.type}}),_vm._v(" "),_c('CertificateExample',{attrs:{"type":_vm.type,"vehicle_type":_vm.vehicle_type}}),_vm._v(" "),_c('SectionTitle',{attrs:{"title":"In soli 3 click"}}),_vm._v(" "),_c('Stepper',{attrs:{"type":_vm.type}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62631c2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/app/components/ProductDefinition.vue
// module id = LukG
// module chunks = 1